import { TimeoutConfig } from 'rxjs';

const TIMEOUT_STORE = 3000;
const TIMEOUT_NETWORK = 30000;

function createTimeoutMeta(msg?: string) {
  return {
    msg,
  };
}

export const networkTimeout = <T>(timeoutMessage?: string): TimeoutConfig<T> => {
  return {
    each: TIMEOUT_NETWORK,
    meta: createTimeoutMeta(timeoutMessage),
  };
};

export const storeTimeout = <T>(errorMessage?: string): TimeoutConfig<T> => {
  return {
    each: TIMEOUT_STORE,
    meta: createTimeoutMeta(errorMessage),
  };
};
